/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CameraIntrinsicsFromJSON, CameraIntrinsicsToJSON, StreemApiPointFromJSON, StreemApiPointToJSON, StreemApiPoseFromJSON, StreemApiPoseToJSON, } from './';
export function StreemApiFulfillStreemshotRequestFromJSON(json) {
    return StreemApiFulfillStreemshotRequestFromJSONTyped(json, false);
}
export function StreemApiFulfillStreemshotRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fulfilledAt': !exists(json, 'fulfilled_at') ? undefined : (new Date(json['fulfilled_at'])),
        'fulfilledByUserSid': !exists(json, 'fulfilled_by_user_sid') ? undefined : json['fulfilled_by_user_sid'],
        'fulfilledByDeviceSid': !exists(json, 'fulfilled_by_device_sid') ? undefined : json['fulfilled_by_device_sid'],
        'storageUrl': !exists(json, 'storage_url') ? undefined : json['storage_url'],
        'pose': !exists(json, 'pose') ? undefined : StreemApiPoseFromJSON(json['pose']),
        'featurePoints': !exists(json, 'feature_points') ? undefined : (json['feature_points'].map(StreemApiPointFromJSON)),
        'cameraIntrinsics': !exists(json, 'camera_intrinsics') ? undefined : CameraIntrinsicsFromJSON(json['camera_intrinsics']),
        'companySid': !exists(json, 'company_sid') ? undefined : json['company_sid'],
    };
}
export function StreemApiFulfillStreemshotRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fulfilled_at': value.fulfilledAt === undefined ? undefined : (value.fulfilledAt.toISOString()),
        'fulfilled_by_user_sid': value.fulfilledByUserSid,
        'fulfilled_by_device_sid': value.fulfilledByDeviceSid,
        'storage_url': value.storageUrl,
        'pose': StreemApiPoseToJSON(value.pose),
        'feature_points': value.featurePoints === undefined ? undefined : (value.featurePoints.map(StreemApiPointToJSON)),
        'camera_intrinsics': CameraIntrinsicsToJSON(value.cameraIntrinsics),
        'company_sid': value.companySid,
    };
}
//# sourceMappingURL=StreemApiFulfillStreemshotRequest.js.map